import React, { useEffect, useState } from "react";
import TransferenciasGlobaisChart from "../components/transferenciasGlobais/TransferenciasGlobaisChart";
import TransferenciasGlobaisTable from "../components/transferenciasGlobais/TransferenciasGlobaisTable";
import TransferenciasGlobaisAnos from "../components/transferenciasGlobais/TransferenciasGlobaisAnos";
import TransferenciasGlobaisTotalCount from "../components/transferenciasGlobais/TransferenciasGlobaisTotalCount";
import Header from "../components/home/Header";
import TransferenciasGlobaisApi from "../services/robinhood/TransferenciasGlobaisApi";
import CategoriasCount from "../components/categorias/CategoriasCount";
import Meses from "../services/Meses";
import TransferenciasGlobaisChartBar from "../components/transferenciasGlobais/TransferenciasGlobaisChartBar";
import NoticiasNotificacao from "../components/noticias/NoticiasNotificacao";
import ParametrosApi from "services/robinhood/ParametrosApi";
import ValoresApi from "services/robinhood/ValoresApi";

export default function TransferenciasGlobais() {

  const transferenciasApi = new TransferenciasGlobaisApi();
  const [anos, setAnos] = useState([]);
  const [meses, setMeses] = useState(Meses);
  const [ano, setAno] = useState(new Date().getFullYear());
  const [dados, setDados] = useState([0]);
  const [transferenciasAll, setTransferenciasAll] = useState([]);
  const [transferencias, setTransferencias] = useState([{ "nome": null, "JANEIRO": null, "FEVEREIRO": null, "MARÇO": null, "ABRIL": null, "MAIO": null, "JUNHO": null, "JULHO": null, "AGOSTO": null, "SETEMBRO": null, "OUTUBRO": null, "NOVEMBRO": null, "DEZEMBRO": null },]);
  // const [logo_cinza, setLogo_cinza] = useState(localStorage.getItem('parametros_logo_cinza') ? JSON.parse(localStorage.getItem('parametros_logo_cinza')).valor : 0);


  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
    start();
  }, []);

  // useEffect(() => {
  //   const parametrosApi = new ParametrosApi();
  //   parametrosApi.all().then(response => {
  //     response.map(parametro => {
  //       if (parametro.id == parametrosApi.logo_exibir) {
  //         localStorage.setItem('parametros_logo_exibir', JSON.stringify({ parametros_logo_exibir: parametro.valor }));
  //       }
  //       if (parametro.id == parametrosApi.logo_cinza) {
  //         localStorage.setItem('parametros_logo_cinza', JSON.stringify({ parametros_logo_cinza: parametro.valor }));
  //       }
  //     });
  //   });
  // }, []);

  const start = async () => {
    transferenciasApi.Anos().then(response => {
      if (response) {
        setAnos(response.reverse());
        setAno(response[0].ano);
        handlerAno(response[0].ano);
      }
    });
    transferenciasApi.All().then(response => {
      if (response) {
        setTransferenciasAll(response);
      }
    });
    new ValoresApi().anos().then(response => {
      if (response) {
        localStorage.setItem('valores_anos', JSON.stringify(response.reverse()));
      }
    });
  }

  const handlerAno = (_ano) => {
    setAno(_ano);
    transferenciasApi.Ano(_ano).then(response => {
      setTransferencias(response.transferencias);
      setMeses(response.meses);
      setDados(response.chartDados);
    });
  }

  return (
    <>
      <Header>
        <h5 style={{ marginLeft: '20px', marginBottom: '-40px' }}> <i className='zmdi zmdi-globe'></i> TRANSFERÊNCIAS ICMS / IPI </h5>
      </Header>
      <section className='content' style={{ marginBottom: '' }}>
        {/* <NoticiasNotificacao></NoticiasNotificacao> */}
        <section className='container-fluid'>
          <div className='row' style={{ marginTop: '' }}>
            <TransferenciasGlobaisTotalCount dados={dados} ano={ano} backgroundColor={''} />
            <TransferenciasGlobaisChartBar anos={anos} transferencias={transferenciasAll} />
          </div >
        </section >

        <TransferenciasGlobaisAnos anos={anos} handlerAno={handlerAno} ano={ano} backgroundColor={''} demaisAnosUrl={'http://robin-hood-historico.fjp.mg.gov.br/index.php/transferencias/global'} />
        <TransferenciasGlobaisChart ano={ano} dados={dados} backgroundColor={''} borderColor={''}  >
          <TransferenciasGlobaisTable meses={meses} transferencias={transferencias} ano={ano} backgroundColor={''} />
        </TransferenciasGlobaisChart>
      </section>
      <div className='' style={{ marginBottom: '-10px' }}></div>

    </>
  )

}